// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from 'firebase/functions';// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD0hMR8zCB4k88NDq05B16ZeckRPv16uw4",
  authDomain: "parm-94786.firebaseapp.com",
  projectId: "parm-94786",
  storageBucket: "parm-94786.firebasestorage.app",
  messagingSenderId: "95137260644",
  appId: "1:95137260644:web:fb1dff438df38a6d602b71",
  measurementId: "G-9DVX07XEP4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app, "parm-membership");
export const storage = getStorage(app);
export const functions = getFunctions(app);

// if (window.location.hostname === 'localhost') {
//   connectFunctionsEmulator(functions, 'localhost', 5001);
//   console.log('🔌 Connected to local Firebase Functions Emulator (Port 5001)');
// }